import { ref } from 'vue'

/**
 * 模擬進度條 Composable
 * 用於在沒有實際進度數據時提供視覺反饋
 */
export function useFakeProgress () {
  const progressPercentage = ref(0)
  let progressInterval = null

  /**
   * 開始模擬進度
   * @param {Object} options - 配置選項
   * @param {number} options.maxPercentage - 最大進度百分比，默認 90
   * @param {number} options.minIncrement - 最小增量，默認 5
   * @param {number} options.maxIncrement - 最大增量，默認 15
   * @param {number} options.minInterval - 最小間隔時間(ms)，默認 1000
   * @param {number} options.maxInterval - 最大間隔時間(ms)，默認 3000
   */
  const startProgress = (options = {}) => {
    const {
      maxPercentage = 90,
      minIncrement = 5,
      maxIncrement = 15,
      minInterval = 1000,
      maxInterval = 3000,
    } = options

    progressPercentage.value = 0

    const updateProgress = () => {
      if (progressPercentage.value < maxPercentage) {
        // 隨機增加進度
        const increment = Math.random() * (maxIncrement - minIncrement) + minIncrement
        progressPercentage.value = Math.floor(Math.min(maxPercentage, progressPercentage.value + increment))

        // 設定下次更新的時間間隔
        const nextInterval = Math.random() * (maxInterval - minInterval) + minInterval
        progressInterval = setTimeout(updateProgress, nextInterval)
      }
    }

    // 開始第一次更新
    updateProgress()
  }

  /**
   * 停止進度模擬
   */
  const stopProgress = () => {
    if (progressInterval) {
      clearTimeout(progressInterval)
      progressInterval = null
    }
  }

  /**
   * 完成進度（設為 100%）
   */
  const completeProgress = () => {
    stopProgress()
    progressPercentage.value = 100
  }

  /**
   * 重置進度（設為 0%）
   */
  const resetProgress = () => {
    stopProgress()
    progressPercentage.value = 0
  }

  return {
    progressPercentage,
    startProgress,
    stopProgress,
    completeProgress,
    resetProgress,
  }
}
